import React from 'react';
import ImageCard from './cards/ImageCard';
import ProductCard from './cards/ProductCard';
import QuoteCard from './cards/QuoteCard';
import TextCard from './cards/TextCard';
import FridgeCard from './cards/FridgeCard';
import PhoneCard from './cards/PhoneCard';
import TextAlignment from '../../components/TextAlignment';
import styles from './XUpCardsSection.module.css';

/**
 * @param {FF.ContentfulXUpCardsSectionProps} props
 */
function XUpCards({
  cards,
  cardTextAlignment,
  className,
  subtitle,
  textAlignment,
  title,
}) {
  if (cards.length === 5) {
    throw new Error(
      `X-Up Cards Section failed -- section "${title}" cannot have 5 cards. Valid options are: 2,3,4,6`,
    );
  }

  return (
    <div className={className}>
      <TextAlignment alignment={textAlignment}>
        {title && <h2 className={styles.header2}>{title}</h2>}
        {subtitle && <p>{subtitle.subtitle}</p>}
      </TextAlignment>
      <TextAlignment alignment={cardTextAlignment}>
        <ul className={styles[`cardsList${cards.length}`]}>
          {cards.map((card, i) => (
            <React.Fragment key={card.contentful_id}>
              {card.__typename === 'ContentfulImageCard' && (
                <ImageCard {...card} className={styles.card} />
              )}
              {card.__typename === 'ContentfulProductCard' && (
                <ProductCard {...card} className={styles.card} />
              )}
              {card.__typename === 'ContentfulQuoteCard' && (
                <QuoteCard {...card} className={styles.card} />
              )}
              {card.__typename === 'ContentfulTextCard' && (
                <TextCard {...card} className={styles.card} />
              )}
              {card.__typename === 'ContentfulFridgeCard' && (
                <FridgeCard {...card} className={styles.card} />
              )}
              {card.__typename === 'ContentfulPhoneCard' && (
                <PhoneCard {...card} className={styles.card} />
              )}
            </React.Fragment>
          ))}
        </ul>
      </TextAlignment>
    </div>
  );
}

export default XUpCards;
